import enUS from '@/locales/en_US'
import { store } from '@/store'
import { ConfigProvider as AntdProvider } from 'antd'
import antdEnUS from 'antd/lib/locale/en_US'
import React from 'react'
import { IntlProvider } from 'react-intl'
import { Provider as ReduxProvider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
interface ProviderContextProps {
  children: React.ReactChild
}

const theme = {
  token: {
    colorPrimary: '#037C4B',
  },
}

export const ProviderContext = ({ children }: ProviderContextProps) => {
  return (
    <IntlProvider locale={navigator.language} messages={enUS}>
      <AntdProvider locale={antdEnUS} theme={theme}>
        <ReduxProvider store={store}>
          <BrowserRouter>{children}</BrowserRouter>
        </ReduxProvider>
      </AntdProvider>
    </IntlProvider>
  )
}
